module.exports = __webpack_public_path__ + "static/media/3.5b32d9ec.jpg";